import { useDispatch } from "react-redux";
import {
  ShowDialogPayload,
  hideDialog,
  showDialog,
} from "../../redux/slices/alert/Alert.slice";

export default function useDialog() {
  const dispatch = useDispatch();
  return {
    showDialog: (dialog: ShowDialogPayload) => dispatch(showDialog(dialog)),
    hideDialog: () => dispatch(hideDialog()),
  };
}
